module.exports = "./img/f10f61aeda67740d3f37540f25c12e5a.png";